import { useRef } from 'react';
import { useSearchParams } from 'react-router';
import { useSetAtom } from 'jotai';
import { useFilterToUrlParser } from 'src/common/components/Filters/hooks/useFilterToUrlParser';
import { dashboardUrlParamsAtom } from 'src/atoms/filters/dashboard';

export const DashboardURLParser = ({ children }: { children: React.ReactElement }) => {
  const [searchParams] = useSearchParams();

  const setURLParams = useSetAtom(dashboardUrlParamsAtom);
  const isMounted = useRef(false);

  useFilterToUrlParser(
    {
      urlSearchParamsAtom: dashboardUrlParamsAtom,
    },
    isMounted.current,
  );

  if (!isMounted.current) {
    setURLParams(searchParams);
    isMounted.current = true;
  }

  return <>{children}</>;
};
